import { render, staticRenderFns } from "./QNumero.vue?vue&type=template&id=0a3308e0"
import script from "./QNumero.vue?vue&type=script&lang=js"
export * from "./QNumero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports